export const investigatorBase = '/api/investigator';
export function evidenceUrl(value, kind) {
    return `${investigatorBase}/investigations/${encodeURIComponent(value.investigation)}/sources/${encodeURIComponent(value.source)}/${kind}`;
}
